import React from 'react';
import PropTypes from 'prop-types';
import AddToBasketButtonWithAjaxCall from '../../AddToBasket/AddToBasketButtonWithAjaxCall';
import { dispatchAddToBasket } from '../productPageBundlesAnalytics';


const AddToBasketButtonForStaticBundle = ({
  psaVariant, id, product, addons, totalPrice, buttonLabel, bundleType
}) => (
  <AddToBasketButtonWithAjaxCall
    psaVariant={psaVariant}
    fupid={id}
    quantity={1}
    mainProductId={product.id}
    mainProductSegmentId={product.segmentId}
    addonProductsIds={addons.map((addon) => addon.id)}
    addonProductsNames={addons.map((addon) => addon.name)}
    addonProductsSegmentIds={addons.map((addon) => addon.segmentId)}
    bundlePrice={parseFloat(totalPrice.match(/\d+(\.\d+)?$/)[0])}
    buttonLabel={buttonLabel}
    full={false}
    beforeAddingToBasket={() => {
      dispatchAddToBasket(
        [id, ...addons.map((addon) => addon.id)],
        bundleType
          
      );
    }}
  />
);

AddToBasketButtonForStaticBundle.propTypes = {
  psaVariant: PropTypes.string,
  id: PropTypes.string.isRequired,
  product: PropTypes.shape({
    id: PropTypes.string,
    segmentId: PropTypes.number
  }).isRequired,
  addons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      segmentId: PropTypes.number
    })
  ).isRequired,
  totalPrice: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  bundleType: PropTypes.string.isRequired

};

AddToBasketButtonForStaticBundle.defaultProps = {
  psaVariant: null
};


export default AddToBasketButtonForStaticBundle;
